export enum EFriendrequestReason {
    Unknown = 0,
    Matchrequest = 1,
    Directrequest = 2,
}